import React from "react";
import "./HomeExpertise.css";

const HomeExpertise = () => {
  return (
    <div className="homeExpertise standard-padding">
      <h1 className="heading homeExpertise-heading">
        Structured B2B Travel Solutions & Expertise
      </h1>

      <div className="d-flex justify-content-between homeExpertise-div">
        <div className="homeExpertise-card2">
          <h3 className="heading homeExpertise-title">
            <img src="/assets/icon5.svg" alt="" className="title-icon" />
            Ground Handling Services
          </h3>
          <ul>
            <li>Hotel Reservations </li>
            <li>Airport Transfers </li>
            <li>Intercity Transport </li>
            <li>Chauffeur Services </li>
            <li>Guided Sightseeing </li>
            <li>Safari Excursions & Activities </li>
            <li>Visa Assistance </li>
            <li>Group Movement Coordination </li>
          </ul>
        </div>

        <div className="homeExpertise-container">
          {/* TOP 3 CARDS */}
          <div className="homeExpertise-card">
            <h3 className="homeExpertise-title heading">
              <img src="/assets/icon6.png" alt="" className="title-icon" />
              Additional & Bespoke Services
            </h3>
            <ul>
              <li>VIP & Meet-and-Greet Services </li>
              <li>Private Tours & Experiences </li>
              <li>Event & Gala Arrangements </li>
              <li>Special Occasion Planning </li>
            </ul>
          </div>

          <div className="homeExpertise-card">
            <h3 className="homeExpertise-title">
              <img src="/assets/icon7.png" alt="" className="title-icon" />
              Who We Work With
            </h3>
            <ul>
              <li>MICE Planners </li>
              <li>Corporate Travel Teams</li>
              <li>Event & Incentive Companies </li>
            </ul>
            <p className="note">We do not sell directly to end clients.</p>
          </div>

          {/* BOTTOM ROW */}
          <div className="homeExpertise-bottom-row">
            <div className="homeExpertise-card full">
              <h3 className="homeExpertise-title">
                How We Manage Your Bookings
              </h3>
              <p className="bottom-text">
                Each booking moves through a structured process—from
                availability checks and confirmations to supplier coordination
                and final reconfirmations before arrival. Our teams stay in
                constant touch with hotels, transport providers, and local
                operators to ensure services run as planned.
              </p>
            </div>

            {/* ICONS */}
            <div className="homeExpertise-icons">
              <a
                href="https://wa.me/+971559886749"
                target="_blank"
                rel="noopener noreferrer"
                className="expertise-btn whatsapp"
              >
                <img src="/assets/icon8.png" alt="whatsapp" />
              </a>

              <a href="tel:+971559886749" className="expertise-btn call">
                <img src="/assets/icon9.png" alt="call" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeExpertise;
